var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.24365 3H5.79139L8.16838 14.8761C8.24948 15.2844 8.47163 15.6512 8.79593 15.9123C9.12022 16.1733 9.52601 16.312 9.94225 16.304H18.5633C18.9795 16.312 19.3853 16.1733 19.7096 15.9123C20.0339 15.6512 20.256 15.2844 20.3371 14.8761L21.7562 7.43468H6.67833M20.3371 19.5868C20.3371 20.3673 19.7044 21 18.9239 21C18.1434 21 17.5107 20.3673 17.5107 19.5868C17.5107 18.8063 18.1434 18.1736 18.9239 18.1736C19.7044 18.1736 20.3371 18.8063 20.3371 19.5868ZM10.7608 19.5868C10.7608 20.3673 10.1281 21 9.34763 21C8.56713 21 7.93442 20.3673 7.93442 19.5868C7.93442 18.8063 8.56713 18.1736 9.34763 18.1736C10.1281 18.1736 10.7608 18.8063 10.7608 19.5868Z",
    stroke: "#272638",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.111408b676a7d2119159f8e7261de260.svg";
export { ForwardRef as ReactComponent };